import * as _ from 'lodash';
import * as DateTimeModule from "react-datetime";
import { useEffect, useState } from 'react';
import { IDocumentsVersion } from '@nkr/models/index';
import { Button, FormControl, Modal } from 'react-bootstrap';
import { Moment } from 'moment';
import { UploadFileType } from './upload-file';
import Dropzone, { DropEvent, FileRejection } from 'react-dropzone';
import styled from 'styled-components';
import usePrevious from '@nkr/services/use-previous';

const DateTime = (DateTimeModule as any).default;

const getColor = (props) => {
    if (props.isDragAccept) {
        return '#00e676';
    }

    if (props.isDragReject) {
        return '#ff1744';
    }

    if (props.isDragActive) {
        return '#2196f3';
    }

    return '#eeeeee';
};

const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    // padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-color: ${props => getColor(props)};
    border-style: dashed;
    background-color: #fafafa;
    color: #bdbdbd;
    outline: none;
    transition: border .24s ease-in-out;
`;

interface IProps {
    show: boolean,
    title: string,
    documentVersions: IDocumentsVersion[],
    type: UploadFileType,
    withVersionHistory?: boolean,
    onSubmit: (file: File, version: number, fileDate: string) => void,
    onCancel: () => void
}

const UploadFileDetails = (props: IProps) => {
    const [files, setFiles] = useState<File[]>([]);
    const [version, setVersion] = useState(-1);
    const [fileDate, setFileDate] = useState('');

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show) {
            setFiles([]);
            setVersion(-1);
            setFileDate('');
        }
    }, [props.show])

    const handleFileDropped2 = (acceptedFiles: File[], fileRejections: FileRejection[], event: DropEvent) => {
        setFiles(acceptedFiles);
    };

    const handleCancelUpload = () => {
        setFiles([]);
    };

    const handleRemoveFile = () => {
        setFiles([]);
    };

    const handleVersionChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        setVersion(parseInt(e.currentTarget.value));
    };

    const handleFileDateChange = (value: string | Moment) => {
        if (typeof (value) == 'string') {

        } else {
            setFileDate(value.format('MM/DD/YYYY'));
        }
    };

    const handleSubmit = () => {
        props.onSubmit(files[0], version, fileDate);
    };

    const documentVersions = _.orderBy(props.documentVersions, x => x.effectiveDate, 'desc');

    const disableUpload = props.type == UploadFileType.WithVersionControl ? files.length == 0 || version == -1 || fileDate == '' : files.length == 0;

    return (
        <Modal bsSize='xs' backdrop='static' show={props.show} onHide={props.onCancel}  >
            <Modal.Header closeButton>
                <Modal.Title>Upload {props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='row'>
                    <div className='col-xs-12 col-lg-12'>
                        <Dropzone
                            onDrop={handleFileDropped2}
                            noKeyboard
                            accept='.pdf'
                        >
                            {({ getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject }) => {
                                return (
                                    <>
                                        <Container {...getRootProps({ isDragActive, isDragAccept, isDragReject })}>
                                            <div style={{ width: '100%', height: 30, display: 'flex', alignItems: 'center' }}>
                                                <div style={{ margin: 'auto', textAlign: 'center' }}>
                                                    <span style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}>Click here</span>
                                                    &nbsp;<span style={{ color: 'black' }}>to select the PDF file or drag & drop the PDF file here...</span>
                                                </div>
                                            </div>
                                            <input {...getInputProps()} />
                                        </Container>

                                        {files.length > 0 && (
                                            <div style={{ padding: 5, width: '100%', borderTop: '1px solid #ddd' }}>
                                                {files.map((file, index) =>
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <div style={{ marginRight: 10 }}>{file.name}</div>
                                                        <div style={{ display: 'flex' }}>
                                                            <Button bsStyle='danger' bsSize='xs' onClick={handleRemoveFile}>Remove</Button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </>
                                );
                            }}
                        </Dropzone>
                    </div>
                </div>

                {props.type == UploadFileType.WithVersionControl && (
                    <>
                        <div className='row' style={{ marginTop: 10 }}>
                            <div className='col-xs-12 col-lg-4'>
                                <label className='control-label' htmlFor='documentVersion' style={{ marginLeft: 5, marginTop: 5 }}>Version:</label>
                            </div>
                            <div className='col-xs-12 col-lg-8'>
                                <FormControl
                                    componentClass='select'
                                    value={version}
                                    onChange={handleVersionChange}
                                >
                                    <option value={-1}>- select -</option>
                                    {documentVersions.map(dv =>
                                        <option value={dv.id}>{dv.versionNumber}</option>
                                    )}
                                </FormControl>
                            </div>
                        </div>

                        <div className='row' style={{ marginTop: 10 }}>
                            <div className='col-xs-12 col-lg-4'>
                                <label className='control-label' htmlFor='' style={{ marginLeft: 5, marginTop: 5 }}>Effective Date:</label>
                            </div>
                            <div className='col-xs-12 col-lg-8'>
                                <DateTime
                                    value={fileDate}
                                    input={true}
                                    dateFormat={'MM/DD/YYYY'}
                                    timeFormat={false}
                                    closeOnSelect={true}
                                    inputProps={{ className: 'form-control' }}
                                    onChange={handleFileDateChange}
                                />
                            </div>
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer >
                <Button bsStyle='primary' disabled={disableUpload} onClick={handleSubmit}>Upload</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default UploadFileDetails;